import { axiosServices } from "./config.services";

export async function RegisterReferred(model) {
  return await axiosServices.post("/referidores/create", model);
}
